export default "__VITE_ASSET__Mj70o7Ub__"